import * as React from "react";
import { View, Text, StyleSheet, Dimensions, Image } from "react-native";
import { PropsDetails } from "../../types";
import { themePattern } from "../../constants/pattern";

import { aminoacidos } from "../../assets/aminoacidos";
import NavDisplayDesktop from "../Nav/NavDisplayDesktop";
import Patrocinadores from "../Shared/Patrocinadores";

const { width, height } = Dimensions.get("window");

export default function HomeDisplay() {
  let logo = require("./../../assets/logo.png");

  function display() {
    if (width <= themePattern.breakpoint.mobile)
      return "A versão “on line” interativa do Disco de Aminoácidos, foi desenvolvida a partir da versão impressa.";
    else
      return "Versão online interativa do Disco de Aminoácidos do Centro de Biotecnologia Molecular Estrutural - CBME, com visualização das moléculas dos aminoácidos com recursos tridimensionais.";
  }

  return (
    <View style={stylesLayout.container}>
      <View style={styles.logoContainer}>
        <Image source={logo} style={styles.logoImage} resizeMode="contain" />
      </View>
      <View style={stylesLayout.text}>
        <View style={styles.text}>
          <Text style={styles.descrebePrimary}>DISCO DE AMINOÁCIDOS</Text>
          <Text style={styles.descrebeSecundary}>{display()}</Text>
        </View>
      </View>

      <View style={stylesLayout.nav}>
        <NavDisplayDesktop />
      </View>

      <View style={stylesLayout.patrocinadores}>
        <Patrocinadores />
      </View>
    </View>
  );
}

function stylesLayoutResp() {
  //Mobile
  if (themePattern.breakpoint.mobile >= width)
    return StyleSheet.create({
      text: {
        flex: 2,
        paddingLeft: themePattern.mobile.retreat,
        paddingRight: themePattern.mobile.retreat,
      },
      patrocinadores: {
        flex: 1,
        backgroundColor: themePattern.desktop.white,
        borderBottomLeftRadius: themePattern.tablet.retreat,
        borderBottomRightRadius: themePattern.tablet.retreat,
        borderTopStyle: "solid",
        borderTopColor: "black",
        borderTopWidth: 2,
      },
      nav: {
        flex: 2,
      },
      container: {
        flex: 1,
        justifyContent: "space-between",
        backgroundColor: themePattern.desktop.color1,
        borderRadius: themePattern.tablet.retreat,
        borderStyle: "solid",
        borderColor: "black",
        borderWidth: 2,
      },
    });
  //Tablet
  else
    return StyleSheet.create({
      text: {
        flex: 3,
        paddingLeft: themePattern.desktop.retreatFull,
        paddingRight: themePattern.desktop.retreatFull,
      },
      patrocinadores: {
        flex: 1,
        backgroundColor: themePattern.desktop.white,
        borderBottomLeftRadius: themePattern.tablet.retreat,
        borderBottomRightRadius: themePattern.tablet.retreat,
        borderTopStyle: "solid",
        borderTopColor: "black",
        borderTopWidth: 2,
      },
      nav: {
        flex: 1,
        backgroundColor: themePattern.desktop.color1,
      },
      container: {
        flex: 1,
        justifyContent: "space-between",
        backgroundColor: themePattern.desktop.color1,
        borderRadius: themePattern.tablet.retreat,
        borderStyle: "solid",
        borderColor: "black",
        borderWidth: 2,
      },
    });
}

const stylesLayout = stylesLayoutResp();

const styles = StyleSheet.create({
  descrebePrimary: {
    color: themePattern.desktop.white,
    fontWeight: "bold",
    fontSize:
      width > 1200
        ? themePattern.desktop.title1
        : width > themePattern.breakpoint.mobile
        ? themePattern.tablet.title2
        : themePattern.mobile.title2,

    textAlign: "center",
  },
  descrebeSecundary: {
    color: themePattern.desktop.white,
    fontSize:
      width > 1200
        ? themePattern.desktop.par1
        : width > themePattern.breakpoint.mobile
        ? themePattern.tablet.par2
        : themePattern.mobile.par2,
    marginTop: themePattern.tablet.retreat,
    textAlign: "center",
  },
  text: {
    flexGrow: 1,
    flex: 1,
    justifyContent: "center",
    paddingTop: width > 1200 ? 75 : 25,
  },
  logoImage: {
    width: 190,
    height: 70,
  },
  logoContainer: {
    width: 200,
    height: 80,
    marginTop:themePattern.mobile.retreat,
    padding: 5,
    alignSelf: "center",
    backgroundColor: themePattern.mobile.white,
    borderRadius: themePattern.tablet.retreat,
  },
});
